export default {
  init() {
    // JavaScript to be fired on the archive page
  },
};
